export default {
    token: null,
}